export default __webpack_public_path__ + "static/kits-distribute-f9a67f3ca3f4d4b40fad9dd89e30ef1b.png";